export const ListQueryKey = 'projectAdminOperates';
export const DetailQueryKey = 'projectAdminOperate';

export const Urls = {
  selectUrl: '/adminoperatelog/list',
  updateUrl: '/adminoperatelog/update',
  deleteUrl: '/adminoperatelog/delete',
  createUrl: '/adminoperatelog/create',
  detailUrl: '/adminoperatelog/info',
};
